import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

import { SeatStatus } from 'config/constants'

export function getStatusColor(status) {
  switch (status) {
    case SeatStatus.Empty:
      return '#ffffff' // white
    case SeatStatus.Available:
      return '#a5d6a7' // light green
    case SeatStatus.Reserved:
      return '#fff59d' // light yellow
    case SeatStatus.Sold:
      return '#ef9a9a' // light red
    case SeatStatus.Disabled:
      return '#bdbdbd' // gray
    case SeatStatus.Blocked:
      return '#90caf9' // light blue
    default:
      return '#ffffff'
  }
}

export function getStatusName(status) {
  switch (status) {
    case SeatStatus.Empty:
      return 'Vacío'
    case SeatStatus.Available:
      return 'Disponible'
    case SeatStatus.Reserved:
      return 'Pendiente'
    case SeatStatus.Sold:
      return 'Vendido'
    case SeatStatus.Disabled:
      return 'Deshabilitado'
    case SeatStatus.Blocked:
      return 'Reservado'
    default:
      return 'Desconocido'
  }
}

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Función para actualizar el grid de asientos, conservando los ya configurados
export const updateSeatsGrid = (newRows, newColumns, currentSeats) => {
  const updatedSeats = []
  for (let row = 1; row <= newRows; row++) {
    for (let column = 1; column <= newColumns; column++) {
      // Si ya existe un asiento en esta posición, lo conserva
      const existing = currentSeats.find(
        (seat) => seat.row === row && seat.column === column
      )
      if (existing) {
        updatedSeats.push(existing)
      } else {
        // Si no existe, se crea con el estado por defecto
        updatedSeats.push({
          row,
          column,
          status: SeatStatus.Available
        })
      }
    }
  }
  return updatedSeats
}

export const cloneSeatsGrid = (newRows, newColumns, currentSeats) => {
  const updatedSeats = []

  for (let row = 1; row <= newRows; row++) {
    for (let column = 1; column <= newColumns; column++) {
      const existing = currentSeats.find(
        (seat) => seat.row === row && seat.column === column
      )

      if (existing) {
        // Si el asiento está vendido o pendiente, se clona como disponible
        const status =
          existing.status === SeatStatus.Sold ||
          existing.status === SeatStatus.Reserved
            ? SeatStatus.Available
            : existing.status

        updatedSeats.push({
          ...existing,
          status
        })
      } else {
        // Si no existe, se crea con el estado por defecto
        updatedSeats.push({
          row,
          column,
          status: SeatStatus.Available
        })
      }
    }
  }

  return updatedSeats
}
